<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHiddenInternal()"
  width="30rem"
  [modalTitle]="modalTitle"
  [showModalTitle]="!!modalTitle"
  [closeBtnEnabled]="false"
  [closeOutsideClickEnabled]="false"
>
  <ng-template modalContent>
    <p class="px-3">
      {{ modalMessage }}
    </p>

    <div class="container-fluid p-3">
      <div class="row justify-content-end gx-2">
        <div class="col-auto">
          <app-button
            styleType="contained"
            buttonType="normal"
            text="Cancelar"
            (click)="_onNegativeClick()"
          ></app-button>
        </div>

        <div class="col-auto">
          <app-button
            styleType="contained"
            buttonType="primary"
            text="Ok"
            (click)="_onPositiveClick()"
          ></app-button>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>
